export default "https://cdn-static.gokick.com/assets/10f8238ac2c3e70096f19214fcd9b55856558067/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";